import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { PaAutopilotSettings } from 'frontend-utils/models/hotel';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isDayInsideAutopilotLeadtimeRange(
  date: string | Date,
  today: Dayjs,
  autopilotSettings: PaAutopilotSettings,
) {
  if (
    autopilotSettings.min_push_lead_time &&
    Number.isInteger(autopilotSettings.min_push_lead_time) &&
    autopilotSettings.min_push_lead_time !== 0
  ) {
    // Note: min_push_lead_time value of 1 means that only today is within the range
    const autopilotLeadtimeEndDate = today.add(
      autopilotSettings.min_push_lead_time - 1,
      'days',
    );

    // '[]' includes start and end date
    if (dayjs(date).isBetween(today, autopilotLeadtimeEndDate, 'day', '[]')) {
      return true;
    }
  }

  return false;
}
